// eslint-disable-next-line no-unused-vars
import React from 'react';
import { func } from 'prop-types';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';

import IPTable from 'Containers/APIIntegrations/IPTable';
import URLFeedGenerator from 'Containers/APIIntegrations/URLFeedGenerator';

const StyledURLFeed = styled.div`
  section {
    margin-bottom: 16px;
    border: 1px solid #e2e2e2;

    .sectionHeader {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 16px;
      background: #f5f7f9;

      h4 {
        padding: 0;
        display: flex;
        align-items: center;
        gap: 8px;
      }
    }

    .sectionBody {
      padding: 16px;
    }
  }
`;

const URLFeed = ({
  setErrors
}) => {
  const theme = useTheme();

  return (
    <StyledURLFeed theme={ theme }>
      <URLFeedGenerator />
      <IPTable setErrors={ setErrors } />
    </StyledURLFeed>
  );
};

URLFeed.propTypes = {
  setErrors: func,
};

URLFeed.displayName = 'URLFeedComponent';

export default URLFeed;
